module.exports = __webpack_public_path__ + "img/custom-report-empty.d16de68f.png";